"use client";

import OptionSelect from "@/components/select/option-select";
import { propertyTypeOption } from "@/constants/propertyType";

interface PropertyTypeSelectProps {
  label?: string;
  placeholder?: string;
  value?: string | null;
  wrapperClassName?: string;
  className?: string;
  onChange?: (value: string | null) => void;
  showClearButton?: boolean;
}

export default function PropertyTypeSelect({
  label = "نوع ملک",
  placeholder = "نوع ملک را انتخاب کنید",
  value,
  onChange,
  wrapperClassName,
  className,
  showClearButton = true,
}: Readonly<PropertyTypeSelectProps>) {
  return (
    <OptionSelect
      options={propertyTypeOption}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      wrapperClassName={wrapperClassName}
      className={className}
      showClearButton={showClearButton}
    />
  );
}
